import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import React from 'react';
import config from 'react-global-configuration';

import './style.scss';

const NodeArticleHighlighted = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const image = entity.getIn(['field_media_image', 0, 'styles', 'paragraph_image'], null);
  const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');
  const language = config.get('DEFAULT_LANGUAGE');
  const link = entity.getIn(['paths', language], entity.get('paths').first());
  const created = entity.getIn(['created', 0, 'value'], entity.getIn(['changed', 0, 'value'], null));

  const date = new Date(created);
  const dateString = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

  return (
    <div className="NodeArticleHighlighted">
      <CoreLink to={link}>
        <div className="NodeArticleHighlighted__image">
          <Image src={image} alt={imageAlt} />
        </div>
        <div className="NodeArticleHighlighted__date">{dateString}</div>
        <h3 className="NodeArticleHighlighted__title asH5">{title}</h3>
      </CoreLink>
    </div>
  );
};

export default NodeArticleHighlighted;
